/**
 * created by tianruojun
 * 选记者
 */
import React, {Component} from 'react';
import {Input, Form, Modal, Checkbox, Icon, Button, Pagination, message} from 'antd';
import BaseComponent from "../../../../base/BaseComponent";
import BaseTable from "../../../components/baseTable/BaseTable";

import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from "../../../../utils";

const {Search} = Input;

export default class TaskReporterIds extends BaseComponent {
    static defaultProps = {
        callBack: (data) => {

        }
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,//控制弹框显示隐藏
            deptId: window.currentUser.deptIds,
            reporterList: [],//请求拿到的数据
            useMediaList: [],  //选中暂存的数据
            confirmMediaList: props.itemValue || [],//确定选中的数据
            indeterminate: true,
            checkedAll: false,
            endDataList: [],//抛出的新对象数组
            // searchVal: '',
            params: {
                size: 10,
                start: 1,
                auth: ["interview_accept"],
                quStr: "",
            },
            count: 0,
            saveSearchVal: '',
            onSearchMediaList: []
            // modalKey: uuid(),
        };
    }

    componentDidMount() {
        this.getReporterList()
    }

    getReporterList = () => {
        this.request({
            url: '/cm-sites-dispatch-product/task/reporter/list',
            method: "post",
            body: this.state.params,
            contentType: 'json',
            callBack: (res) => {
                let list = [];
                let count = 0;
                if (res && res.data && res.data.length) {
                    list = res.data.map(item => ({
                        reporter: {
                            account: item.account,
                            name: item.name,
                            depts: item.depts,
                            currentDept:item.currentDept,
                            id:item.user._id
                        },
                        jinxingzhong: item.jinxingzhong,
                        weilingqu: item.weilingqu,
                        yiwancheng: item.yiwancheng,
                    }));
                    count = res.count
                }
                this.setState({
                    count,
                    reporterList: list,
                }, () => {
                    // console.log(this.state.reporterList)
                })
            }
        })
    };

    render() {
        return (
            <div>
                <Form.Item label={this.props.label} required={this.props.required}
                           style={{display: "flex", alignItems: "center"}}
                           labelCol={{span: 5}} wrapperCol={{span: 20}}>
                    {this.renderAdd()}
                    <Scrollbars autoHeight
                                autoHeightMax={242}
                                autoHide
                                style={{width:'660px',marginTop:'20px'}}
                    >
                    {this.renderReporterList()}
                    </Scrollbars>
                </Form.Item>
                {this.renderModal()}
            </div>
        );
    };

    /**
     * 添加记者按钮
     * 点击打开添加弹窗
     * */
    renderAdd = () => {
        return (
            <div style={{
                width: 660,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <div
                    onClick={() => {
                        this.showModal()
                    }}
                    style={{
                        width: 600,
                        height: 32,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: 5,
                        background: "transparent",
                        border: "1px dashed #d9d9d9",
                        cursor: "pointer",
                    }}
                >
                    <Icon type="plus"/>
                    添加记者
                </div>
            </div>
        )
    };

    /**
     * 已选的记者列表
     * 可以删除或设置记者类别
     * */
    renderReporterList = () => {
        let {confirmMediaList} = this.state;
        if (!(confirmMediaList.length > 0)) {
            return ""
        }
        let columns = [
            {
                title: '记者',
                dataIndex: 'reporter.name',
                width:150,
                ellipsis:true,
                key: 'reporter.name',
                render: (text, record) => {
                    return text
                }
            },
            {
                title: '部门',
                width:150,
                dataIndex: 'reporter.currentDept.name',
                render:(text,record)=>{
                    return(
                        <div style={{width: '115px',overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace:'nowrap'}}>{text}</div>
                    )
                }
            },
            {
                title: '类别',
                dataIndex: 'taskRole',
                key: 'taskRole',
                width:300,
                ellipsis:true,
                render: (text, record) => {
                    let getBorderColor = (btn) => {
                        return text && text.indexOf(btn) > -1 ? this.themeBgColor : "rgba(0, 0, 0, 0.15)"
                    };
                    let getColor = (btn) => {
                        return text && text.indexOf(btn) > -1 ? this.themeBgColor : "rgba(0, 0, 0, 0.65)"
                    };
                    let btnListConfig = [
                        {
                            key: "wzjz",
                            value: "文字记者",
                        },
                        {
                            key: "syjz",
                            value: "摄影记者",
                        },
                        {
                            key: "sxjz",
                            value: "摄像记者",
                        },
                    ];
                    return (
                        <div style={{display: "flex"}}>
                            {
                                btnListConfig.map(item => {
                                    let val = item.value;
                                    return (
                                        <div
                                            key={item.key}
                                            onClick={() => {
                                                if (text && text.indexOf(val) > -1) {
                                                    record.taskRole = record.taskRole.filter(Item => Item !== val)
                                                } else {
                                                    record.taskRole.push(val)
                                                }
                                                this.setState({}, () => {
                                                    console.log("confirmMediaList==========", this.state.confirmMediaList)
                                                    console.log('record', record)
                                                    this.props.callBack && this.props.callBack(this.state.confirmMediaList);
                                                });
                                            }}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: 72,
                                                height: 24,
                                                background: "#fff",
                                                borderWidth: "1px",
                                                borderStyle: "solid",
                                                borderColor: getBorderColor(val),
                                                borderRadius: 5,
                                                marginRight: 16,
                                                cursor: "pointer",
                                                color: getColor(val),
                                            }}>
                                            {item.value}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )
                }
            },
            {
                title: '操作',
                dataIndex: 'reporter.account',
                key: 'reporter.account',
                render: (text, record) => {
                    return <div onClick={() => {
                        this.setState({confirmMediaList: confirmMediaList.filter(item => item.reporter.account !== record.reporter.account||item.reporter.currentDept.id!==record.reporter.currentDept.id)}, () => {
                            message.destroy();
                            message.success("删除成功");
                            this.props.callBack && this.props.callBack(this.state.confirmMediaList);
                        })
                    }} style={{color: this.themeBgColor, cursor: "pointer"}}>删除</div>
                }
            },
        ];
        return (
            <BaseTable columns={columns} dataSource={confirmMediaList} />
        )
    };

    /**
     * 所有记者列表
     * 可以选择记者并回显
     * */
    renderModal = () => {
        return (
            <Modal
                title="选择记者"
                visible={this.state.visible}
                onOk={() => {
                    this.onClickConfirm(this.state.useMediaList);
                    this.hideModal();
                }}
                onCancel={this.hideModal}
                okText="确认"
                cancelText="取消"
                width={800}
                style={{position: "relative"}}
            >
                <div style={{maxHeight: 530}}>
                    {/*搜索*/}
                    {this.renderSearch()}
                    <Scrollbars
                        autoHeight={true}
                        autoHeightMax={420}
                        style={{borderBottom: '1px solid #EEF2FB'}}
                    >
                        <BaseTable columns={this.getColumns()}
                                   dataSource={this.state.reporterList}/>
                    </Scrollbars>
                    {/*翻页*/}
                    {this.state.reporterList && this.state.reporterList.length > 0 ?
                        <Pagination style={{marginTop: 18, display: 'flex', justifyContent: 'flex-end'}}
                                    current={this.state.params.start} onChange={this.onPageChange}
                                    onShowSizeChange={this.onPageChange}
                                    total={this.state.count}/> : ''}
                </div>
            </Modal>
        )
    };
    //搜索框
    renderSearch = () => {
        return (
            <div style={{marginBottom: 20}} id={'taskReporterSearch'}>
                <Search
                    value={this.state.saveSearchVal}
                    placeholder="请输入关键词"
                    onSearch={value => this.onSearch(value)}
                    style={{width: 250}}
                    onChange={e => {
                        this.setState({saveSearchVal: e.target.value})
                    }}
                />
                <style>
                    {`#taskReporterSearch .ant-input-affix-wrapper .ant-input{
                            background-color: #F6F8FD
                        }
                    `}
                </style>
            </div>
        )
    };

    //分页
    onPageChange = (page,size) => {
        let params = JSON.parse(JSON.stringify(this.state.params));
        params.start = page;
        params.size = size;
        this.setState({
            params
        }, () => {
            this.getReporterList()
        })
    }


    //点击搜索
    onSearch(value) {
        console.log(value)
        let params = JSON.parse(JSON.stringify(this.state.params))
        params.quStr = value;
        params.start=1;
        this.setState({
            params,
        }, () => {
            this.getReporterList()
        })
    }


    //点击确定
    onClickConfirm = () => {
        let newData = JSON.parse(JSON.stringify(this.state.useMediaList));
        // 外层数据中存有记者类型参数，不能直接赋值
        if (newData && newData.length) {
            newData = newData.map(item => {
                if (!this.state.confirmMediaList.some(Item => Item.reporter.account === item.reporter.account&&Item.reporter.currentDept.id === item.reporter.currentDept.id)) {
                    return {
                        reporter: item.reporter,
                        taskRole: [],
                    }
                    // this.state.confirmMediaList.push({
                    //     reporter: item.reporter,
                    //     taskRole: [],
                    // })
                } else {
                    return this.state.confirmMediaList.find(Item => Item.reporter.account === item.reporter.account&&Item.reporter.currentDept.id === item.reporter.currentDept.id)
                }
            })
        }
        this.setState({
            confirmMediaList: newData,
            // endDataList: newData
        }, () => {
            this.props.callBack && this.props.callBack(this.state.confirmMediaList);
            console.log('确定选中的数据', this.state.confirmMediaList)
        })
    };


    //拿到当前所选列表
    //根据checked选中或未选中，重新组织当前所选列表
    //checked是true，则把当前record push到当前所选列表zhong ,如果是false则通过filter把当前数据从所选列表中过滤掉并重新赋值
    //刷新页面
    weight = (list) => {
        let newList = [];
        list.forEach(item => {
            if (newList.every(item2 => item2.reporter.account !== item.reporter.account || item.reporter.currentDept.id!==item2.reporter.currentDept.id)) {
                newList.push(item)
            }
        });
        return newList
    };
    cancel=(list)=>{
        let reporterList=this.state.reporterList
        let newList=[]
        list.forEach(item=>{
            if(reporterList.every(item2=>item2.reporter.account !== item.reporter.account || item.reporter.currentDept.id!==item2.reporter.currentDept.id)){
                newList.push(item)
            }
        })
        return newList
    }

    //全选
    checkedAllChange(checked) {
        if (checked) {
            // if (this.state.saveSearchVal) {
                this.setState({useMediaList: this.weight([...this.state.reporterList, ...this.state.useMediaList])})
            // } else {
            //     this.setState({useMediaList: this.state.reporterList})
            // }
        } else {
            this.setState({useMediaList: this.cancel([...this.state.useMediaList])});
        }
    }

    //单选
    simpleCheckedChange(checked, record) {
        console.log(checked, record);
        if (checked) {
            this.state.useMediaList.push(record);
        } else {
            this.state.useMediaList = this.state.useMediaList.filter(item => item.reporter.account !== record.reporter.account || item.reporter.currentDept.id!==record.reporter.currentDept.id);
        }
        this.setState({}, () => {
            console.log(this.state.useMediaList)
        });
    }


    //表格列
    getColumns = () => {
        return [
            {
                title: (() => {
                    //拿到当前所选的所有数据
                    //拿到当前列表所有数据
                    //比对两个列表长度是否相等
                    //如果长度相等则为全选
                    //如果长度不相等，并且所选有数据，则为半选
                    //最后，当前所选数据为空，则为不选
                    let checkedAll = false;
                    let indeterminate = false;
                    if (this.state.reporterList.length > 0 && this.state.useMediaList && this.state.useMediaList.length > 0) {
                        checkedAll = this.state.reporterList.every(item => this.state.useMediaList.some(item2 => item2.reporter.account === item.reporter.account && item.reporter.currentDept.id===item2.reporter.currentDept.id));
                        indeterminate = !checkedAll && this.state.reporterList.some(item => this.state.useMediaList.some(item2 => item2.reporter.account === item.reporter.account && item.reporter.currentDept.id===item2.reporter.currentDept.id))
                    } else {
                        checkedAll = false;
                        indeterminate = !checkedAll && this.state.reporterList.some(item => this.state.useMediaList.some(item2 => item2.reporter.account === item.reporter.account && item.reporter.currentDept.id===item2.reporter.currentDept.id))
                    }
                    return (
                        <Checkbox checked={checkedAll} indeterminate={indeterminate} onChange={(e) => {
                            this.checkedAllChange(e.target.checked);
                        }}/>
                    )
                })(),
                align: 'center',
                width: 50,
                key: "checked",
                render: (text, record) => {
                    //拿到当前这条数据record
                    //拿到当前所选所有数据
                    //判断当前数据是否在所选列表中，如在则为选中，否则为未选中
                    let checked = false;
                    let useMediaList = this.state.useMediaList;
                    if (useMediaList && useMediaList.length) {
                        checked = useMediaList.some(item => item.reporter.account === record.reporter.account && item.reporter.currentDept.id === record.reporter.currentDept.id);
                    }
                    return (
                        <div>
                            <Checkbox checked={checked} onChange={(e) => {
                                this.simpleCheckedChange(e.target.checked, record)
                            }}/>
                        </div>
                    )
                }
            },
            {
                title: '记者姓名',
                dataIndex: 'reporter.name',
                width: 150,
                ellipsis:true,
            },
            {
                title: '记者账号',
                dataIndex: 'reporter.account',
                width: 100,
            },
            {
                title: '部门',
                dataIndex: 'reporter.currentDept.name',
                width: 150,
                render:(text,record)=>{
                    return(
                        <div style={{width: '115px',overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace:'nowrap'}}>{text}</div>
                    )
                }
            },
            {
                title: '未领取',
                dataIndex: 'weilingqu',
                width: 100,
            },
            {
                title: '进行中',
                dataIndex: 'jinxingzhong',
                width: 100,
            },
            {
                title: '已完成',
                dataIndex: 'yiwancheng',
                width: 100,
            },
        ];

    };

    hideModal = () => {
        this.setState({
            modalKey: uuid(),
            visible: false,
            saveSearchVal: ''
        });
    };

    showModal = () => {
        let data = JSON.parse(JSON.stringify(this.state.confirmMediaList));
        let params = JSON.parse(JSON.stringify(this.state.params));
        params.quStr = '';
        params.start = 1;
        this.setState({
            useMediaList: data,
            visible: true,
            params,
        }, () => {
            this.getReporterList()
            // this.refreshChecked()
        });
    };

    //refresChecked
    refreshChecked() {
        let useMediaList = this.state.useMediaList;
        if (useMediaList && useMediaList.length && this.state.reporterList && this.state.reporterList.length) {
            this.state.reporterList.forEach((item, index) => {
                this.state.reporterList[index].checked = useMediaList.some(item2 => item2.reporter.account === item.reporter.account);
            })
        }
        this.setState({})
    }
}
